import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const DivisionsLayout = lazy(() => import('@/pages/divisions/layout'));
const DivisionsPage = lazy(() => import('@/pages/divisions'));
const CreateDivisionPage = lazy(() => import('@/pages/divisions/create'));
const DivisionSegmentLayout = lazy(() => import('@/pages/divisions/[divisionId]/layout'));
const UpdateDivisionPage = lazy(() => import('@/pages/divisions/[divisionId]/update'));
const ViewDivisionPage = lazy(() => import('@/pages/divisions/[divisionId]/view'));

export const divisionRoutes: RouteConfig = {
  path: '/divisions',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: DivisionsLayout,
      children: [
        {
          path: '',
          element: DivisionsPage,
        },
        {
          path: '/create',
          element: CreateDivisionPage,
        },
        {
          path: '/:divisionId',
          layout: DivisionSegmentLayout,
          children: [
            {
              path: '/view',
              element: ViewDivisionPage,
            },
            {
              path: '/update',
              element: UpdateDivisionPage,
            },
          ],
        },
      ],
    },
  ],
};
